import ApiService from "./api.service";

export default class GoogleService extends ApiService {
  static base_url = `${super.base_url}/google/map/distance_time`;

  static async getDistanceAndTime(data, axiosInstance) {
    const response = await axiosInstance.post(this.base_url, data);
    return response;
  }
}
